














import { Vue, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ICustomer, IProject, IMarkers } from '@/interfaces/data';
import store from '@/store';
import {
  SET_FILTERING_ELEMENT_DISABLED,
  SET_SLIDER_FILTERING_DISABLED,
  SET_RADIOGROUP_FILTERING_DISABLED,
  CHANGE_RADIO_GROUP_TEXT,
  CHANGE_SLIDER_MODEL_VALUE,
  SET_TEMP_MARKERS,
  ADD_MARKER_TO_TEMPMARKERS,
  SET_FILTERING_STATE_TO_DEFAULT,
  CLEAR_TEMPMARKERS,
  SET_OVERLAY_DISPLAY
} from '@/store/constants/mutation-types';
@Component
export default class MarkersFilteringView extends Vue {
  @(namespace('MarkersFilteringModule').State('sliderElementDisabled'))
  private sliderElementDisabled;

  set sliderDisabled(value) {
    store.commit(
      `MarkersFilteringModule/${SET_SLIDER_FILTERING_DISABLED}`,
      value
    );
  }

  get sliderDisabled() {
    return this.sliderElementDisabled;
  }

  @(namespace('MarkersFilteringModule').State('radioGroupElementDisabled'))
  private radioGroupElementDisabled;

  set radioGroupDisabled(value) {
    store.commit(
      `MarkersFilteringModule/${SET_RADIOGROUP_FILTERING_DISABLED}`,
      value
    );
  }

  get radioGroupDisabled() {
    return this.radioGroupElementDisabled;
  }

  @(namespace('MarkersFilteringModule').State('sliderModel'))
  private sliderModelState;

  set sliderModelValue(value) {
    store.commit(`MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`, value);
  }

  get sliderModelValue() {
    return this.sliderModelState;
  }

  @(namespace('MarkersFilteringModule').State('radioGroup'))
  private radioGroupState;

  set radioGroupValue(value) {
    store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, value);
  }

  get radioGroupValue() {
    return this.radioGroupState;
  }

  @(namespace('LocationModule').State('markers')) private markers!: IMarkers[];

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  @(namespace('LocationModule').Mutation(CLEAR_TEMPMARKERS))
  private clearTempMarkers!: () => void;

  private handleRadioFiltering(e) {
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, true);
    this.clearTempMarkers();
    switch (this.radioGroupValue) {
      case 'covered':
        this.markers.forEach(marker => {
          for (const m of marker.margins) {
            if (this.radioGroupValue === 'covered') {
              if (marker.coverage && m >= this.sliderModelValue) {
                store.commit(
                  `LocationModule/${ADD_MARKER_TO_TEMPMARKERS}`,
                  marker
                );
                break;
              }
            }
          }
        });
        store.commit(
          `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
          false
        );
        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        break;

      case 'notCovered':
        store.commit(
          `LocationModule/${SET_TEMP_MARKERS}`,
          this.markers.filter(marker => !marker.coverage)
        );
        this.sliderModelValue = 0;
        this.sliderDisabled = true;
        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        break;

      case 'all':
        this.markers.forEach(marker => {
          for (const m of marker.margins) {
            if (m >= this.sliderModelValue) {
              store.commit(
                `LocationModule/${ADD_MARKER_TO_TEMPMARKERS}`,
                marker
              );
              store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
              break;
            }
          }
        });
        store.commit(
          `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
          false
        );
        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        break;
    }
  }

  private destroyed() {
    store.commit(`MarkersFilteringModule/${SET_FILTERING_STATE_TO_DEFAULT}`);
  }
}
